import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "color-picker" }
const _hoisted_2 = {
  key: 0,
  class: "preview-row"
}
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = {
  key: 1,
  class: "info"
}
const _hoisted_5 = { class: "info-colors" }
const _hoisted_6 = {
  key: 2,
  class: "combos"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isPreviewRow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "preview",
            style: _normalizeStyle({ background: _ctx.hex }),
            "aria-hidden": "true"
          }, null, 4),
          _createVNode(_component_app_input, {
            modelValue: _ctx.hex,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hex) = $event)),
            "is-label": false
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", {
            class: "copy-icon",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyTextColor && _ctx.copyTextColor(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, {
              size: "xl",
              icon: ['fas', 'copy']
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        ref: "svEl",
        class: "sv",
        style: _normalizeStyle({ background: _ctx.svBackground }),
        onPointerdown: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSvPointerDown && _ctx.onSvPointerDown(...args)), ["prevent"]))
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "sv-overlay" }, null, -1)),
        _createElementVNode("div", {
          class: "sv-cursor",
          style: _normalizeStyle(_ctx.svCursorStyle),
          "aria-hidden": "true"
        }, null, 4)
      ], 36),
      _createElementVNode("div", {
        ref: "hueEl",
        class: "hue",
        onPointerdown: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onHuePointerDown && _ctx.onHuePointerDown(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", {
          class: "hue-cursor",
          style: _normalizeStyle(_ctx.hueCursorStyle),
          "aria-hidden": "true"
        }, null, 4)
      ], 544)
    ]),
    (_ctx.isInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("strong", null, "HEX:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.hex), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("strong", null, "RGB:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.rgb.join(', ')), 1)
            ])
          ]),
          (_ctx.isInfoBtn)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "info-button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openCombinationCanvasModal && _ctx.openCombinationCanvasModal(...args)))
              }, [
                _createVNode(_component_app_button, {
                  icon: ['fas', 'eye'],
                  raised: "",
                  severity: "secondary"
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isCombosSection)
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.t('combinations')), 1),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combos, (c) => {
              return (_openBlock(), _createElementBlock("div", {
                key: c.label,
                class: "combo"
              }, [
                _createElementVNode("div", {
                  class: "swatch",
                  style: _normalizeStyle({ background: c.color })
                }, null, 4),
                _createElementVNode("div", _hoisted_8, _toDisplayString(c.label) + " — " + _toDisplayString(c.color), 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("h4", null, _toDisplayString(_ctx.t('scale')), 1),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scaleColors, (s) => {
              return (_openBlock(), _createElementBlock("div", {
                key: s,
                class: "swatch",
                style: _normalizeStyle({ background: s })
              }, null, 4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}